<template>
  <div>
    <div class="w-100 d-inline-block 
    pets-banner-slider">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-6 col-12 col-sm-7 
          col-md-7">
             <div class="w-100 d-inline-block home-banner-heading">
               <h1 class="half-black fw-bold filson-black-family text-capitalize">
                Book Best Mobile Pet Grooming Service In Dubai With Us
              </h1>
              <p class="text-black text-size-15 margin-bottom-3 inter-regular-family w-85 margin-xl-top-3 w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-full-14">
                Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We are here to offer a wide range of mobile pet grooming services designed to meet your pet's needs.
              </p>
              <div class="w-100 d-inline-block text-xs-center">
                <router-link class="text-white text-size-14 d-inline-block book-online-btn border-green bg-green inter-bold-family me-2 text-full-11" to="/booking/">
                  <img src="@/assets/images/book-online-icon.svg" alt="picture" class="me-2 h-16">
                  BOOK NOW
              </router-link>
              <a class="text-white text-size-14 d-inline-block bg-call inter-bold-family whats-btn text-uppercase text-full-11" href="javascript:void(0)" @click="openWhatsApp">
                <i class="fa fa-whatsapp text-size-20 text-full-18 me-2 float-start" aria-hidden="true"></i>
                WhatsApp 
              </a>
              </div>
             </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-5 mt-sm-5 mt-xl-0 col-md-5">
            <div class="w-100 d-inline-block banner-pets-image text-center mt-1 mb-1 mt-sm-5 mt-xl-0 mt-md-0 mb-xl-0 mb-5 mb-sm-0 mb-md-0">
              <img class="w-100" v-lazy="require('@/assets/images/pet-grooming-pet-groomer.webp')" alt="pet grooming, pet groomer">
            </div>
          </div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'bannerComponent',
  // Add component logic here if needed
data() {
       return {
        
       }
     },

methods:{
      openWhatsApp() {
        window.dispatchEvent(new CustomEvent('open-whatsapp-chat'));
  },
   async callClick() {
       try {
        const payload = {
          website_name: this.$websiteName,
          type: 'whatsapp',
        
        };
        const response = await this.$axios.post('/click-count', payload);
        console.log('Response:', response.data);
        
      } catch (err) {
        console.error('Error during call click:', err);
      }
    },

}




}


</script>

<style scoped>
/* Add styles specific to this component here */
</style>
